import store from '@/store';
import {loanInputStoppingCase} from '@/util/dictList'
export const option = {
  height: 'auto',
  calcHeight: 80,
  tip: false,
  delBtn: false,
  editBtn: false,
  editBtnText: "修改数量",
  editTitle: "修改数量",
  addBtn: false,
  searchShow: true,
  searchMenuSpan: 6,
  searchLabelWidth: 100,
  labelWidth: 150,
  border: true,
  index: false ,
  menu:true,
  indexLabel: '序号',
  selection: false,
  viewBtn: false,
  dialogType: 'dialog',
  dialogClickModal: false,
  rowKey: 'index',
  column: [
    {
        label: "代理商简称",
        prop: "id",
        type: "select",
        filterable: true,
        search: true,
        searchClearable: true,
        defaultExpandAll: true,
        searchOrder: 1000,
        hide: true,
        dicData: store.getters.companies,
        props: {
            label: "title",
            value: "id",
        },
    },
    {
      label: "停止进件原因",
      prop: "loanInputStoppingCase",
      type: "select",
      search: true,
      hide: true,
      searchOrder: 999,
      dicData: loanInputStoppingCase
  },
  ],
}

// 已控制
export const controlledColumn = [
  {
    label: '代理商简称',
    prop: 'deptName',
    span: 24,
    display: false,
  },
  {
    label: '停止进件',
    prop: 'loanInput',
    span: 24,
    display: false,
    formatter: (val, value, label) => {
      return value ? '否' : '是';
    },
  },
  {
    label: '停止返佣',
    prop: 'stopRebate',
    span: 24,
    display: false,
    formatter: (val, value, label) => {
      return value ? '是' : '否';
    },
  },
  {
    label: '停止进件原因',
    prop: 'stopReason',
    span: 24,
    type: "select",
    display: false,
    dicData: loanInputStoppingCase
  },
]

// 控制记录
export const controlRecordColumn = [
  {
    label: '功能模块',
    prop: 'functionModule',
    span: 24,
    display: false,
    type: "select",
    dicData: [{
      label: '停止进件',
      value: 0,
    }, {
      label: '恢复进件',
      value: 1,
    }, {
      label: '停止返佣',
      value: 2,
    },{
      label: '恢复返佣',
      value: 3,
    }]
  },
  {
    label: '代理商简称',
    prop: 'deptName',
    span: 24,
    display: false,
  },
  {
    label: '原因',
    prop: 'reason',
    type: "select",
    span: 24,
    display: false,
    dicData: loanInputStoppingCase,
    formatter: function(row, column) {
      let item = loanInputStoppingCase.find(item => item.value === row.reason);
      return item?.label ??'/' ;
    },
  },
  {
    label: '操作人',
    prop: 'operator',
    span: 24,
    display: false,
  },
  {
    label: '操作时间',
    prop: 'operationTime',
    span: 24,
    display: false,
  },
]
